export default {
  socialMedias: [
    { 
      name: 'Facebook',
      model: 'facebook',
      iconClass: 'uil-facebook text-primary'
    },
    { 
      name: 'Twitter',
      model: 'twitter',
      iconClass: 'uil-twitter twitter'
    },
    { 
      name: 'Dribble',
      model: 'dribble',
      iconClass: 'uil-dribbble text-danger'
    },
    { 
      name: 'Behance',
      model: 'behance',
      iconClass: 'uil-behance'
    },
  ],
  personalDetails: [
    { 
      name: "Email", 
      iconClass: 'uil-envelope',
      model: 'email'
    },
    {
      name: "Phone",
      iconClass: 'uil-phone',
      model: 'contact_no'
    },
    {
      name: "Location",
      iconClass: 'uil-location-point',
      model: ['city', 'country']
    },
    {
      name: "Website",
      iconClass: 'uil-globe',
      model: 'website'
    }
  ],
  smallCards: [
    {
      name: "Industries",
      iconClass: 'uil-building',
      model: 'industry_id',
      noContentMessage: 'No Available Industry(s).'
    },
    {
      name: "Functions",
      iconClass: 'uil-cog',
      model: 'function_id',
      noContentMessage: 'No Available Function(s).'
    },
    {
      name: "Brands",
      iconClass: 'uil-building',
      model: 'brand_id',
      noContentMessage: 'No Available Brand(s).'
    }
  ],
  rightSideCard: [
    {
      name: "Contact Person",
      model: "contact_person",
      emptyMessage: "No Available Contact Person(s)"
    },
    {
      name: "Contract Start Date",
      model: 'contract_start_date',
      emptyMessage: "N/A"
    },
    {
      name: 'Contract End Date',
      model: 'contract_end_date',
      emptyMessage: "N/A"
    }
  ]
}